// Firebase is loaded lazily (dynamic import) so the SDK stays out of the
// initial bundle and page chunks; analytics init is kicked off right after
// app mount (see main.js) or on first logged event, whichever comes first.

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
  authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.VUE_APP_FIREBASE_APP_ID,
  measurementId: process.env.VUE_APP_FIREBASE_MEASUREMENT_ID
};

let analyticsPromise = null;

function initFirebaseAnalytics() {
  if (!analyticsPromise) {
    analyticsPromise = Promise.all([
      import(/* webpackChunkName: "firebase" */ "firebase/app"),
      import(/* webpackChunkName: "firebase" */ "firebase/analytics"),
    ])
      .then(([{ initializeApp }, { getAnalytics, logEvent }]) => {
        const firebaseApp = initializeApp(firebaseConfig);
        return { analytics: getAnalytics(firebaseApp), logEvent };
      })
      .catch((error) => {
        if (process.env.NODE_ENV !== "production") {
          console.error("[firebase.initFirebaseAnalytics] Failed to load Firebase SDK:", error);
        }
        // Do not cache the failure: allow the next call to retry the import
        // (e.g. after a transient network drop or mid-deploy chunk 404).
        analyticsPromise = null;
        return null;
      });
  }
  return analyticsPromise;
}

function firebaseLogEvent(eventName, eventParams) {
  initFirebaseAnalytics().then((firebase) => {
    if (firebase) {
      firebase.logEvent(firebase.analytics, eventName, eventParams);
    }
  });
}

const FIREBASE_EVENTS = {
  REGISTRATION_FAILED: "registration_failed"
}

export {initFirebaseAnalytics, firebaseLogEvent, FIREBASE_EVENTS}
